/** Regras puras da importação Ativos CX. CPF é a unidade de trabalho. */
export type IncomingLead = {
 cpf: string; registration: string; name?: string;
 balance?: number | null; eligibility?: string; phone?: string;
};
export type ExistingClient = { cpf: string; ownerId: string | null };
export type Assignment = { cpf: string; ownerId: string; newClient: boolean };
export type ImportIssue = { row: number; message: string };
export const onlyDigits = (value: unknown) => String(value ?? '').replace(/\D/g, '').padStart(11,'0');
export function validateCpf(value: unknown): boolean {
 const s=onlyDigits(value);
 if(s.length!==11 || /^(\d)\1{10}$/.test(s))return false;
 const check=(n:number)=>{let sum=0;for(let i=0;i<n;i++)sum+=Number(s[i])*(n+1-i);const d=(sum*10)%11;return d===10?0:d};
 return check(9)===Number(s[9]) && check(10)===Number(s[10]);
}
export function distributeCxLeads(
 rows: IncomingLead[], existing: ExistingClient[], activeOperatorIds: string[],
 existingLoads: Record<string,number>={}
): { assignments: Assignment[]; issues: ImportIssue[]; accounts: IncomingLead[] } {
 const ids=[...new Set(activeOperatorIds.filter(Boolean))].sort();
 const issues:ImportIssue[]=[];const accounts:IncomingLead[]=[];
 const clients=new Set<string>();const owners=new Map(existing.map(c=>[onlyDigits(c.cpf),c.ownerId]));
 const load=new Map(ids.map(id=>[id,Math.max(0,existingLoads[id]??0)]));
 for(const [i,row] of rows.entries()){
  const cpf=onlyDigits(row.cpf),registration=String(row.registration??'').trim();
  if(!validateCpf(cpf)){issues.push({row:i+2,message:'CPF inválido'});continue}
  accounts.push({...row,cpf,registration});clients.add(cpf);
 }
 const assignments:Assignment[]=[];
 for(const cpf of [...clients].sort()){
  const current=owners.get(cpf);
  if(current){assignments.push({cpf,ownerId:current,newClient:false});continue}
  if(ids.length===0){issues.push({row:0,message:'Nenhum operador ativo selecionado'});break}
  const ownerId=[...ids].sort((a,b)=>(load.get(a)??0)-(load.get(b)??0)||a.localeCompare(b))[0];
  assignments.push({cpf,ownerId,newClient:true});load.set(ownerId,(load.get(ownerId)??0)+1);
 }
 return {assignments,issues,accounts};
}
